import React, { useState } from 'react';
import { Box, Flex, Heading, Text, useMediaQuery } from '@chakra-ui/react';
import { DiMysql } from 'react-icons/di';
import { TbBrandCSharp } from 'react-icons/tb';
import { FaGolang } from 'react-icons/fa6';

function Profile() {
  const NUM_TIME = 3;
  const UNIT_TIME = 'Years';

  const [isNotSmallerScreen] = useMediaQuery('(min-width: 600px)');
  const [bgColorCSharp, setbgColorCSharp] = useState('blue.400');
  const [bgColorMySql, setbgColorMySql] = useState('gray.100');
  const [bgColorGo, setbgColorGo] = useState('gray.100');
  const [numberColor, setnumberColor] = useState('blue.400');

  const handleCardClick = event => {
    if (event.target.id === 'C') {
      setbgColorCSharp('blue.400');
      setbgColorMySql('gray.100');
      setbgColorGo('gray.100');
      setnumberColor('blue.400');
    } else if (event.target.id === 'G') {
      setbgColorGo('cyan.400');
      setbgColorCSharp('gray.100');
      setbgColorMySql('gray.100');
      setnumberColor('cyan.400');
    } else {
      setbgColorMySql('green.400');
      setbgColorCSharp('gray.100');
      setbgColorGo('gray.100');
      setnumberColor('green.400');
    }
  };

  return (
    <Flex
      direction={isNotSmallerScreen ? 'row' : 'column'}
      w="100%"
      maxWidth={{ base: '100vh', md: '130vh', lg: '130vh', xl: '130vh' }}
    >
      <Box alignSelf="center" px={isNotSmallerScreen ? '32' : '3'} py="16">
        <Heading fontWeight="extrabold" color={numberColor} size="4xl">
          {NUM_TIME}+
        </Heading>
        <Text fontSize="2xl" color="gray.400">
          {UNIT_TIME} of Experience
        </Text>
      </Box>
      <Box alignSelf="center" px={isNotSmallerScreen ? '32' : '3'} py="16">
        <Text fontWeight="bold" fontSize="2xl">
          Backend-focused Software Engineer specializing in cloud infrastructure
          and scalable systems.
        </Text>
        <Flex
          direction={isNotSmallerScreen ? 'row' : 'column'}
          mt={8}
          alignItems={isNotSmallerScreen ? 'inherit' : 'center'}
        >
          <Flex
            id="C"
            onClick={handleCardClick}
            rounded="xl"
            direction="column"
            mt={4}
            ml={isNotSmallerScreen ? 4 : 0}
            bg={bgColorCSharp}
            h="30vh"
            w="30vh"
            justify="flex-end"
            _hover={{ bg: 'blue.400', cursor: 'pointer' }}
          >
            <Box id="C" pl="4">
              <TbBrandCSharp id="C" color="black" size={80} />
            </Box>
            <Text
              id="C"
              color="black"
              p="4"
              fontSize="xl"
              fontWeight="semibold"
            >
              C#
            </Text>
          </Flex>
          <Flex
            id="G"
            onClick={handleCardClick}
            rounded="xl"
            direction="column"
            mt={4}
            ml={isNotSmallerScreen ? 4 : 0}
            bg={bgColorGo}
            h="30vh"
            w="30vh"
            justify="flex-end"
            _hover={{ bg: 'cyan.400', cursor: 'pointer' }}
          >
            <Box id="G" pl="4">
              <FaGolang id="G" color="black" size={80} />
            </Box>
            <Text
              id="G"
              color="black"
              p="4"
              fontSize="xl"
              fontWeight="semibold"
            >
              Go
            </Text>
          </Flex>

          <Flex
            id="M"
            onClick={handleCardClick}
            rounded="xl"
            direction="column"
            mt={4}
            ml={isNotSmallerScreen ? 4 : 0}
            bg={bgColorMySql}
            h="30vh"
            w="30vh"
            justify="flex-end"
            _hover={{ bg: 'green.400', cursor: 'pointer' }}
          >
            <Box id="M" pl="4">
              <DiMysql id="M" color="black" size={80} />
            </Box>
            <Text
              id="M"
              color="black"
              p="4"
              fontSize="xl"
              fontWeight="semibold"
            >
              SQL
            </Text>
          </Flex>
        </Flex>
      </Box>
    </Flex>
  );
}

export default Profile;
